export function validateGroupName(name) {
  if (!name || name.trim().length === 0) {
    return 'Group name is required';
  }

  if (name.trim().length < 2) {
    return 'Group name must be at least 2 characters long';
  }

  if (name.length > 50) {
    return 'Group name must be less than 50 characters';
  }

  return null;
}
